import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import { AppLink, AppAd } from '../functional';

interface AppNavOwners {
    data: any
}


export const AppNavOwners: FunctionalComponent<AppNavOwners> = ({ data }) => {

    if (!data) return;

    const list1 = get(data, 'List1') || [];
    const list2 = get(data, 'List2') || [];


    return (
        <div class="uk-navbar-dropdown uk-width-1-1 uk-padding ">
            {/* <image class="uk-preserve uk-position-absolute wsio-tick-nav" data-src="/assets/images/tick.svg" uk-svg></image> */}
            <div class="uk-nav uk-navbar-dropdown-nav">
                <div uk-grid>
                    <div class="uk-width-1-1 uk-width-1-2@m uk-width-2-5@l">
                        <ul class="uk-nav">
                            <li class="uk-heading-small wsio-gold uk-margin-small-bottom">{data.Label1}</li>
                            <li class="uk-nav-divider"></li>
                            <div class="uk-nav uk-column-1-2 uk-column-1-1@m">
                                {
                                    list1.map((Link) => <li>{(get(Link, 'Label') || get(Link, 'Icon')) ? <AppLink className='uk-navbar-dropdown-close wsio-nav-link  color-primary' data={Link} /> : <div class="uk-margin-top"></div>}</li>)
                                }
                            </div>
                        </ul>
                    </div>
                    <div hidden={!data.Label2} class="uk-width-1-1 uk-width-1-2@m uk-width-2-5@l">
                        <ul class="uk-nav">
                            <li class="uk-heading-small wsio-gold uk-margin-small-bottom">{data.Label2}</li>
                            <li class="uk-nav-divider"></li>
                            <div class="uk-nav uk-column-1-2 uk-column-1-1@m">
                            {
                                list2.map((Link) => <li>{(get(Link, 'Label') || get(Link, 'Icon')) ? <AppLink className='uk-navbar-dropdown-close wsio-nav-link  color-primary' data={Link} /> : <div class="uk-margin-top"></div>}</li>)
                            }
                            </div>
                        </ul>
                    </div>
                    <div hidden={data.CTA1} class="uk-width-1-1 uk-margin-medium-top"></div>
                    <div hidden={!data.CTA1} class="uk-width-1-1 uk-margin-medium-top">
                        {data.CTA1 && <AppAd Title={get(data, 'CTA1.Title')} Description={get(data, 'CTA1.Description')} Media={get(data, 'CTA1.Media')} Link={get(data, 'CTA1.Link')} />}
                    </div>
                </div>
                <ul>

                </ul>
            </div>
        </div>
    )
};